//https://angular.io/guide/dynamic-component-loader
import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
    // eslint-disable-next-line @angular-eslint/directive-selector
    selector: '[quizQuestionPartChoicesHost]',
    standalone: true
})
export class QuizQuestionPartChoicesDirective {
   constructor(public viewContainerRef: ViewContainerRef) {
      //console.log('constructor:QuizQuestionPartChoice directive');
   }
}
